const Linkedin = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_937_750)'>
      <path
        d='M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z'
        fill='white'
      />
      <path
        d='M12.0792 23.4821H8.76295V12.8132H12.0792V23.4821Z'
        fill='#121432'
      />
      <path
        d='M10.4228 11.3549C10.0426 11.355 9.67085 11.2423 9.35467 11.0311C9.03849 10.8199 8.79205 10.5197 8.64648 10.1685C8.50091 9.8172 8.46276 9.43067 8.53687 9.05774C8.61098 8.68481 8.79402 8.34223 9.06283 8.07333C9.33164 7.80442 9.67416 7.62126 10.0471 7.54702C10.42 7.47277 10.8065 7.51077 11.1578 7.65622C11.5091 7.80166 11.8094 8.04801 12.0207 8.36411C12.232 8.68022 12.3448 9.05189 12.3449 9.43211C12.3449 9.68457 12.2952 9.93456 12.1987 10.1678C12.1021 10.4011 11.9606 10.613 11.7821 10.7916C11.6036 10.9701 11.3917 11.1118 11.1584 11.2084C10.9252 11.3051 10.6752 11.3549 10.4228 11.3549Z'
        fill='#121432'
      />
      <path
        d='M21.1858 18.2941C21.1858 17.057 21.1638 15.4645 19.4629 15.4645C17.7375 15.4645 17.4735 16.8123 17.4735 18.2041V23.4817H14.1607V12.8132H17.341V14.2712H17.3855C17.7037 13.727 18.1637 13.2793 18.7162 12.9759C19.2688 12.6724 19.8933 12.5245 20.5233 12.5478C23.8809 12.5478 24.5 14.7564 24.5 17.6295L24.4986 23.4821H21.1858V18.2941Z'
        fill='#121432'
      />
    </g>
    <defs>
      <clipPath id='clip0_937_750'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default Linkedin
